import { render } from "./BaseButton.vue?vue&type=template&id=b9a6e70c&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=b9a6e70c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a6e70c"]])

export default __exports__